var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "us_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v12H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#us_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h16v12H0V0z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1v1h16V1H0zm0 2v1h16V3H0zm0 3V5h16v1H0zm0 1v1h16V7H0zm0 3V9h16v1H0zm0 2v-1h16v1H0z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E42A5",
    d: "M0 0h9v7H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04 2.174l.53-.37.41.297h-.232l.47.416-.158.584h-.25l-.241-.536-.206.536H.748l.47.416-.178.657.53-.37.41.297h-.232l.47.416-.158.584h-.25l-.241-.536-.206.536H.748l.47.416-.178.657.53-.37.512.37-.159-.657.412-.416h-.19l.425-.296.41.296h-.232l.47.416-.178.657.53-.37.512.37-.159-.657.412-.416h-.19l.425-.296.41.296h-.232l.47.416-.178.657.53-.37.512.37-.159-.657.412-.416h-.19l.425-.296.41.296h-.232l.47.416-.178.657.53-.37.512.37-.159-.657.412-.416H7.81l-.242-.536-.206.536h-.298l-.142-.584.412-.416h-.19l.425-.296.512.369-.159-.657.412-.416H7.81l-.242-.536-.206.536h-.298l-.142-.584.412-.416h-.19l.425-.296.512.369-.159-.657.412-.416H7.81L7.569.565l-.206.536h-.615l.47.416-.158.584h-.25l-.241-.536-.206.536h-.298l-.142-.584.412-.416H5.81L5.569.565l-.206.536h-.615l.47.416-.158.584h-.25l-.241-.536-.206.536h-.298l-.142-.584.412-.416H3.81L3.569.565l-.206.536h-.615l.47.416-.158.584h-.25l-.241-.536-.206.536h-.298l-.142-.584.412-.416H1.81L1.569.565l-.206.536H.748l.47.416-.178.657zM7.06 4.1l.159-.584-.471-.416h.233l-.411-.296-.425.296h.19l-.412.416.142.584h.298l.206-.536.242.536h.249zm-1.08 0l-.41-.296-.425.296h.19l-.412.416.142.584h.298l.206-.536.242.536h.249l.159-.584-.471-.416h.233zm-1.761.416l-.16.584h-.248l-.242-.536-.206.536h-.298l-.142-.584.412-.416h-.19l.425-.296.41.296h-.232l.47.416zm.144-.416h-.298l-.142-.584.412-.416h-.19l.425-.296.41.296h-.232l.47.416-.158.584h-.25l-.241-.536-.206.536zm-1.303 0l.159-.584-.47-.416h.232l-.411-.296-.425.296h.19l-.412.416.142.584h.298l.206-.536.242.536h.249zm3.159-1.584l-.16.584h-.248l-.242-.536-.206.536h-.298l-.142-.584.412-.416h-.19l.425-.296.41.296h-.232l.47.416zM3.98 2.1l-.411-.296-.425.296h.19l-.412.416.142.584h.298l.206-.536.242.536h.249l.159-.584-.471-.416h.233z",
    fill: "#F7FCFF"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 11,
    rx: 0.5,
    stroke: "#000",
    strokeOpacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }));
}

export default __webpack_public_path__ + "static/media/us.7a7fb6bc.svg";
export { SvgUs as ReactComponent };